import { Map, fromJS } from 'immutable';

import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, dataTableParamFormatter, errorActionWithAlert, mapToQueryParams } from '@sophocles/utils';

export function fetchJobsWithFilters(filterObject) {
  return tableParams => dispatch => {
    const params = Map(filterObject).merge(dataTableParamFormatter(tableParams));
    return apiClient
      .get(`/jobs/?${mapToQueryParams(params)}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOBS')));
  };
}

export function fetchJobsForSite(siteId) {
  return dispatch =>
    apiClient
      .get(`/jobs/`, { params: { site: siteId } })
      .then(checkHttpStatus)
      .then(response => response.data.results)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOBS')));
}

export function fetchJob(jobId) {
  return dispatch =>
    apiClient
      .get(`/jobs/${jobId}/`)
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOBS')));
}

export function generateChangeOrderInvoice(jobId) {
  return dispatch =>
    apiClient
      .get(`/jobs/${jobId}/changeorder/`)
      .then(checkHttpStatus)
      .then(response => {
        return response.data;
      });
}

export function generateFixtureSwapInvoice(jobId) {
  return dispatch =>
    apiClient
      .get(`/jobs/${jobId}/fixtureswapinvoice/`)
      .then(checkHttpStatus)
      .then(response => {
        return response.data;
      });
}

export function patchJob(jobId, values) {
  return dispatch =>
    apiClient
      .patch(`/jobs/${jobId}/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Work form updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return response.data;
      })
      .catch(error => dispatch(errorActionWithAlert(error, 'EDIT_JOB')));
}

export function createJob(values) {
  return dispatch =>
    apiClient
      .post(`/jobs/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Work form submitted',
            level: 'success',
            dismissible: true,
          }),
        );
        return response.data;
      })
      .catch(error => dispatch(errorActionWithAlert(error, 'CREATE_JOB')));
}

export function approveJob(jobId, values) {
  return dispatch =>
    apiClient
      .post(`/jobs/${jobId}/approve/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Work form approved',
            level: 'success',
            dismissible: true,
          }),
        );
        return response.data;
      })
      .catch(error => dispatch(errorActionWithAlert(error, 'APPROVE_JOB')));
}

export function revertJob(jobId, values) {
  return dispatch =>
    apiClient
      .post(`/jobs/${jobId}/unapprove/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Work form reverted',
            level: 'success',
            dismissible: true,
          }),
        );
        return response.data;
      })
      .catch(error => dispatch(errorActionWithAlert(error, 'REVERT_JOB')));
}

export function deleteJob(jobId) {
  return dispatch =>
    apiClient
      .delete(`/jobs/${jobId}/`)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Work form deleted',
            level: 'success',
            dismissible: true,
          }),
        );
        return true;
      })
      .catch(error => dispatch(errorActionWithAlert(error, 'DELETE_JOB')));
}

export function fetchJobsSpreadsheetWithFilters(filterObject) {
  return dispatch => {
    const params = Map(filterObject);
    return apiClient
      .get(`/jobs/xlsx/?${mapToQueryParams(params)}`)
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOBS_XLSX')));
  };
}

export function calculateServicesForJob(jobId, values) {
  return dispatch =>
    apiClient
      .post(`/jobs/${jobId}/calculateservices/`, values)
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'CALCULATE_JOB_SERVICES')));
}
